import Ctx, { drawCircle, drawText } from "./Ctx";

type NetworkStructure = number[]; // input, hidden[], output

// const sigmoid = z => 1 / (1 + Math.pow(Math.E, -z));

const random = () => Math.random() * 2 - 1;
const sigmoid = z => (1 / (1 + Math.exp((-z)/1)));
const sigmoidf = (a = 1, b = 0) => z => (1 / (1 + Math.exp(-a*(z-b))));

const MUTATION_CHANCE = .2;
const MUTATION_FORCE = .1;

class Neuron {
    private weights: number[];
    private lastValue: number;

    constructor(inputs: number, weights?: number[]) {
        this.weights = weights || [...Array(inputs)].map(() => random());
    }

    public forward(values: number[]): number {
        return this.lastValue = sigmoid(
            values.map((v, i) => (this.weights[i] || 1) * v)
                .reduce((a, v) => a + v, 0)
        );
    }

    public randomize(): Neuron {
        return new Neuron(null, this.weights.map(v => Math.random() > MUTATION_CHANCE ? v : v + random() * MUTATION_FORCE));
    }

    public getLastValue(): number {
        return this.lastValue;
    }
}

export default class NeuralNet {
    private structure: NetworkStructure;
    private neurons: Neuron[][];

    constructor(structure: NetworkStructure, neurons?: Neuron[][]) {
        this.structure = structure;
        this.neurons = neurons || structure.map((v, i, a) =>
            [...Array(v)].map(() => new Neuron(i == 0 ? 0 : a[i - 1]))
        );
    }

    public forward(values: number[]): number[] {
        if(values.length != this.neurons[0].length) {
            console.error('Input length not equal to input neuron layer');
            return;
        }

        const result = [...Array(this.neurons.length)];
        this.neurons[0].forEach((v, i) => v.forward([values[i]]));
        this.neurons.forEach((layer, i) => result[i] = i == 0 ? values : layer.map(neuron => neuron.forward(result[i - 1])));

        // console.log(result);
        return result[result.length - 1];
    }

    public nextGeneration(): NeuralNet {
        return new NeuralNet(this.structure, this.neurons.map(layer => layer.map(neuron => neuron.randomize())));
    }

    // public breed(a: NeuralNet, b: NeuralNet): NeuralNet {
    //     return new NeuralNet(this.structure, this.neurons.map(layer => layer.map(neuron => )))
    // }

    public draw(ctx: CanvasRenderingContext2D): void {
        const radius = 50;
        const padding = 10;

        const tallest = Math.max(...this.structure) * (radius + padding);

        this.neurons.forEach((layer, layeri, layerarr) => {

            layer.forEach((neuron, neuroni) => {
                const height = radius * 2 + padding + neuroni * (radius * 2 + padding);
                const missing = (tallest - layer.length * (radius * 2)) / 2;
                const lastValue = neuron.getLastValue();

                // const sigmoid = z => (.5 / (1 + Math.exp((-z)/1)));

                const color = (sigmoidf(10, .5)(lastValue)) * 255;
                // console.log(sigmoidf(10, 0)(lastValue));

                drawCircle(
                    ctx,
                    radius + layeri * (radius * 2 + padding),
                    height + missing,
                    radius,
                    [color, 0, 0, color]
                );

                if(lastValue)
                    drawText(
                        ctx,
                        `${neuron.getLastValue().toFixed(4)}`,
                        radius + layeri * (radius * 2 + padding) - padding * 2,
                        height + missing + padding / 2,
                        [255, 255, 255, 255]
                    );

                if(layeri == 0) return;
            });
        });
    }
}